const KEY = 'autoProcess'

export const saveAutoProcessToStorage = (value: boolean) => {
  localStorage.setItem(KEY, value.toString());
}

export const loadAutoProcessFromStorage = (): boolean => {
  return Boolean(localStorage.getItem(KEY));
}

export const removeAutoProcessFromStorage = () => {
  localStorage.removeItem(KEY)
}
